import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { mapPlaylistCardToContentCardItem, openPlaylistCard } from '@app/app/shared/collections/card-item/card-item-content-card.mapper';
import { cardItemJoin } from '@app/app/shared/collections/card-item/card-item-join';
import { V3ContentCardComponent } from '@app/app/shared/components-v3/content-card/v3-content-card.component';
import { V3ContentCardRow } from '@app/app/shared/components-v3/content-card/v3-content-card.model';
import { PlaylistCardShort } from '@app/app/shared/models';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { LucideCheck } from '@lucide/angular';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'ptl-card-item-snake-view',
  standalone: true,
  imports: [V3ContentCardComponent, IconComponent],
  templateUrl: './card-item-snake-view.component.html',
  styleUrls: ['./card-item-snake-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardItemSnakeViewComponent {
  private readonly transloco = inject(TranslocoService);

  card = input.required<PlaylistCardShort>();
  cardIndex = input(0);
  reservedRows = input<V3ContentCardRow[]>([]);

  cardClick = output<PlaylistCardShort>();

  protected readonly join = cardItemJoin(this.card);

  protected readonly LucideCheck = LucideCheck;

  protected readonly cardItem = computed(() => mapPlaylistCardToContentCardItem(this.join.card(), this.cardIndex(), this.transloco));

  protected readonly completed = computed(() => {
    const progress = this.cardItem().progress;
    return this.card().completed === true || (progress !== null && progress !== undefined && progress >= 100);
  });

  protected readonly engaged = computed(() => {
    const item = this.cardItem();
    return this.card().started === true || !!item.statusBadge || (item.progress !== null && item.progress !== undefined);
  });

  onCardOpen(): void {
    openPlaylistCard(this.card(), (card) => this.cardClick.emit(card));
  }
}
